// src/store/lookupsSelectors.js
export const selectInstitutionData = (state) => state.lookups.institutionData;
export const selectEmployees = (state) => state.lookups.employees;
export const selectCurrentEmployee = (state) => state.lookups.currentEmployee;
export const selectCustomers = (state) => state.lookups.customers;
export const selectSuppliers = (state) => state.lookups.suppliers;
export const selectPreviousDue = (state) => state.lookups.previousDue;
export const selectLoadIntoAccs = (state) => state.lookups.loadIntoAccs;
export const selectTaxAccs = (state) => state.lookups.taxAccs;
export const selectCurrentAssetAccs = (state) => state.lookups.curAssAccs;
export const selectDiscountAccs = (state) => state.lookups.discountAccs;
export const selectSalaryAccs = (state) => state.lookups.salaryAccs;
export const selectItems = (state) => state.lookups.items;
export const selectGroups = (state) => state.lookups.groups;
export const selectOrigins = (state) => state.lookups.origins;
export const selectItemModels = (state) => state.lookups.itemModels;
export const selectItemRacks = (state) => state.lookups.itemRacks;
export const selectItemUnit = (state) => state.lookups.itemUnit;
export const selectCategories = (state) => state.lookups.categories;
export const selectBatchAvailability = (state, itemId) =>
  (state.lookups.batchAvailability && itemId
    ? state.lookups.batchAvailability[itemId]
    : []) || [];
export const selectUsers = (state) => state.lookups.users;
export const selectUserRoles = (state) => state.lookups.userRoles;
export const selectTagGroups = (state) => state.lookups.tagGroups;
export const selectTagFields = (state) => state.lookups.tagFields;
export const selectWarehouses = (state) => state.lookups.warehouses;
export const selectLocations = (state) => state.lookups.locations;
export const selectDashboardStats = (state) => state.lookups.dashboardStats;
export const selectDashboardLastSevenMonthSalesAndPurchase = (state) => state.lookups.dashboardLastSevenMonthSalesAndPurchase;
export const selectDashboardLoading = (state) =>
  state.lookups.loading.dashboardStats;
export const selectGenericNames = (
  state
) => state.lookups.genericNames;
